import angular from 'angular';
import assetFinanceDetails from './assetFinanceDetails';

export default angular
  .module('components.assetFinanceDetails', [])
  .component('assetFinanceDetails', assetFinanceDetails).name;
